module.exports = "https://secnetweb.ksyun.com/KEC/ksc-node-kvm/assets/ionicons.2c2ae068be3b089e0a5b59abb1831550.eot";